import React from 'react';

import { ScreenEvent } from '@confluence/analytics/entry-points/ScreenEvent';

type AnalyticsScreenEventProps = {
	name: string;
	level: string;
	type: string;
	objectId?: string;
	additionalAttributes?: Object;
};

export const AnalyticsScreenEvent = ({
	name,
	level,
	type,
	objectId,
	additionalAttributes,
}: AnalyticsScreenEventProps) => (
	<ScreenEvent
		name={name}
		id="none"
		attributes={{
			native: true,
			level,
			type,
			objectId: objectId || 'none',
			...additionalAttributes,
		}}
	/>
);
